<template>
  <div>
    <div class="fixed_page"  id="blurry">
      <div class="get-started">
    <div class="fixed_page">
      <div class="achievements_box">
        <img src="static/images/achievements/Store-MainL.png">
          <h1>{{ getTranslations.home_achievements_title }}</h1>
          <p>{{ getTranslations.home_achievements_description }}</p>
      </div>
      <div class="soccer_background">

        <div class="get_started_list_section achievements_section achievements_main">

          <div class="filter">
            <a v-for="(achievement, index) in achievements"
                  :key="index"
                  :class="[ changeClass(index), {current: activeTab === index }]"
                  href="#"
                  @click.prevent="changeTab(index)">
            {{ getTranslatedValue(index + 1) }}
          </a>
          </div>
          <div class="filter_list">
            <div :class="['list_item', changeClass(activeTab)]">
              <achievements-tab v-for="(achievement, index) in achievements"
                                :key="index"
                                :is-active="activeTab === index"
                                :categories="achievement.achievementDTOs"/>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AchievementsTab from '@/components/home/modals/achievements/AchievementsTab';

export default {
  name: 'achievements',
  components: {
    AchievementsTab,
  },
  data() {
    return {
      activeTab: 0,
    };
  },

  methods: {
    changeClass(index) {
      if (index === 0) {
        return 'grand';
      } else if (index === 1) {
        return 'weekly';
      }
      return 'monthly';
    },
    changeTab(index) {
      this.activeTab = index;
    },
    getTranslatedValue(index) {
      return this.getTranslations[`home_achievements_category${index}`];
    },
  },
  computed: {
    ...mapState('profile', [
      'achievements',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Achievements.vue